import { render, staticRenderFns } from "./Configuracao.vue?vue&type=template&id=903ad038&scoped=true"
import script from "./Configuracao.vue?vue&type=script&lang=js"
export * from "./Configuracao.vue?vue&type=script&lang=js"
import style0 from "./Configuracao.vue?vue&type=style&index=0&id=903ad038&prod&lang=scss&scoped=true"
import style1 from "./Configuracao.vue?vue&type=style&index=1&id=903ad038&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "903ad038",
  null
  
)

export default component.exports